import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["toggle", "foundValue", "enrichedValue", "enrichedRow"]
  static outlets = ["toggleable-bar"]

  connect() {
    this.showEnrichedValues = this.hasToggleTarget ? this.toggleTarget.checked : false;
    // Add transition classes to all enriched rows
    this.enrichedRowTargets.forEach(row => {
      row.classList.add("transition-colors", "duration-300", "ease-in-out");
    });
    this.updateDisplay();
  }

  toggleView() {
    if (!this.hasToggleTarget) return;
    this.showEnrichedValues = this.toggleTarget.checked;
    this.updateDisplay();

    // Update all connected toggleable-bar outlets
    this.toggleableBarOutlets.forEach(outlet => {
      outlet.syncToDataset(this.showEnrichedValues ? "enriched" : "raw");
    });
  }

  updateDisplay() {
    if (this.showEnrichedValues) {
      // Show enriched values, hide found values
      this.foundValueTargets.forEach(target => target.classList.add("hidden"));
      this.enrichedValueTargets.forEach(target => target.classList.remove("hidden"));
      // Update row backgrounds for enriched rows
      this.enrichedRowTargets.forEach(row => {
        // Store original confidence class before removing it
        const confidenceClasses = ["bg-error/10", "bg-warning/10", "bg-success/10", "bg-info/10"];
        const originalClass = confidenceClasses.find(cls => row.classList.contains(cls));
        if (originalClass) {
          row.dataset.originalConfidenceClass = originalClass;
          row.classList.remove(originalClass);
        }
        row.classList.add("bg-primary/10");
      });
    } else {
      // Show found values, hide enriched values
      this.foundValueTargets.forEach(target => target.classList.remove("hidden"));
      this.enrichedValueTargets.forEach(target => target.classList.add("hidden"));
      // Restore original confidence-based backgrounds for enriched rows
      this.enrichedRowTargets.forEach(row => {
        row.classList.remove("bg-primary/10");
        // Restore the original confidence class
        const originalClass = row.dataset.originalConfidenceClass;
        if (originalClass) {
          row.classList.add(originalClass);
          delete row.dataset.originalConfidenceClass;
        }
      });
    }
  }
}